module.exports = __webpack_public_path__ + "img/avatar6.53677200.png";